<template>
  <BSkeletonWrapper
    :loading="loading"
  >
    <template #loading>
      <BCard>
        <BCardText>
          <div class="d-flex flex-column justify-content-center mb-3">
            <BSkeleton
              width="65%"
              height="23px"
              class="mb-2"
            />
            <BSkeleton
              width="80%"
              height="18px"
            />
          </div>
        </BCardText>

        <BCardText>
          <BRow class="gap-y-4">
            <BCol
              v-bind="childColumns"
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>

            <BCol
              v-bind="childColumns"
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>

            <BCol
              v-bind="childColumns"
              cols="12"
            >
              <BRow class="gap-y-2">
                <BCol
                  cols="12"
                  md="4"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
                <BCol
                  cols="12"
                  md="8"
                  class="text-right"
                >
                  <BSkeleton
                    width="100%"
                    height="18px"
                  />
                </BCol>
              </BRow>
            </BCol>
          </BRow>
        </BCardText>
      </BCard>
    </template>

    <BCard
      body-class="p-2"
      class="rounded-lg"
    >
      <BCardText class="p-0">
        <div class="d-flex gap-3">
          <div class="d-flex flex-column align-items-center justify-content-center gap-2">
            <CircleProgress
              :value="eventProgress"
              :variant="variant(eventProgress)"
              :size="50"
            />
          </div>
          <div class="d-flex justify-content-center align-items-start flex-grow-1 gap-3">
            <div class="d-flex flex-column flex-grow-1 gap-1 py-1">
              <div class="d-flex gap-2 border-bottom pb-1">
                <b
                  style="font-size: 0.8rem;"
                  class="text-primary"
                >{{ memo?.memo_name }}</b>
              </div>
              <div
                class="d-flex justify-content-between align-items-center gap-2"
              >
                <div
                  style="font-size: 10px;"
                  class="d-flex justify-content-between flex-grow-1 gap-2"
                >
                  <div>
                    <b :class="['text-muted', `text-danger`]">{{ memo.invalid }}</b> Invalid / <b :class="['text-muted', `text-primary`]">{{ memo.valid }}</b> Valid
                  </div>
                  <div>
                    <b :class="['text-muted', `text-${variant(eventProgress)}`]">{{ currentProgress.event }}</b> Conducted / <b class="text-muted">{{ totalProgress.event }}</b> Assigned
                  </div>
                </div>
              </div>
            </div>
            <div class="h-100 d-flex align-items-center">
              <slot name="footer" />
            </div>
          </div>
        </div>
      </BCardText>
    </BCard>
  </BSkeletonWrapper>
</template>
<script>
import CircleProgress from '@/components/custom/CircleProgress.vue'

import MxFormatter from '@/mixins/formatter'

export default {

  name: 'DGATaskEventsTask',

  components: {
    CircleProgress
  },

  mixins: [
    MxFormatter
  ],

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },
    childColumns: {
      type: Object,
      default: () => ({})
    },
    memo: {
      type: Object,
      required: true,
      default: () => ({
        id: '',
        memo_name: '',
        valid: 0,
        invalid: 0
      })
    },
    totalProgress: {
      type: Object,
      required: true,
      default: () => ({
        event: 0
      })
    },
    currentProgress: {
      type: Object,
      required: true,
      default: () => ({
        event: 0
      })
    }
  },

  computed: {
    eventProgress () {
      const events = this.currentProgress.event / this.totalProgress.event
      if (isNaN(events) || !isFinite(events)) {
        return 0
      }

      return events * 100
    }
  },

  methods: {
    variant (progress) {
      if (progress >= 75) {
        return 'success'
      } else if (progress >= 31) {
        return 'warning'
      } else if (progress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    }
  }
}
</script>
